import {ReactNode} from 'react'
import './Typography.scss'

export const Headline = ({title, children}: { title: string, children?: ReactNode }) => {
    return <h3 className="headline" title={title}>{children ? children : title}</h3>
}